import React, { forwardRef } from "react";
import Link from "next/link";
import { blue, gray, green, orangeDark, pink, purple } from "../../../../theme";
import { ChevronRight } from "@untitled-ui/icons-react";
import styles from "./mobileNavMenuItem.module.scss";

export const MobileNavMenuItem = forwardRef((props: Props, ref: any) => {
  const colors: any = {
    pink: pink,
    blue: blue,
    green: green,
    orangedark: orangeDark,
    gray: gray,
    purple: purple,
  };

  return (
    <Link
      href={props.url}
      className={styles.link}
      ref={ref}
      onClick={props.onClick}
    >
      {props.icon}
      <div className={styles.wrapper1}>
        <div className={styles.wrapper2}>
          <p className={styles.title}>{props.title}</p>
          {props.badgeColor && (
            <div
              className={styles.badge}
              style={{ backgroundColor: colors[props.badgeColor][50] }}
            >
              <p
                className={styles.badgeText}
                style={{ color: colors[props.badgeColor][600] }}
              >
                {props.badgeText}
              </p>
            </div>
          )}

          <ChevronRight
            style={{
              marginLeft: "auto",
            }}
            width={20}
            color={gray[500]}
          />
        </div>
      </div>
    </Link>
  );
});

interface Props {
  title: string;
  icon?: JSX.Element;
  url: string;
  badgeText?: string;
  badgeColor?: "green" | "blue" | "red" | "gray";
  onClick?: () => void;
}
